import React from "react";

export type typeSaleAmount = {
  variant?: string;
};

export const SaleAmount: React.FC<typeSaleAmount> = () => {
  return <div className="pt-8">Sale amount</div>;
};
